import { k as jsxRuntimeExports } from "./doenetml-a_KitGQm.js";
import React__default from "react";
import { u as useDoenetRenderer } from "./useDoenetRenderer-Ca2HvWV4.js";
const hr = React__default.memo(function Hr(props) {
  let { id, SVs } = useDoenetRenderer(props);
  if (SVs.hidden) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("hr", { id });
});
export {
  hr as default
};
